import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Text } from 'foundations-components/components/Text';
import { DownCaratIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SelectButtonContent = () => /*#__PURE__*/_jsxs(TFlex, {
  align: "center",
  justify: "center",
  children: [/*#__PURE__*/_jsx(Text, {
    as: "span",
    color: "text-tertiary-default",
    typography: "body-100",
    marginInlineEnd: "100",
    children: /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmObjectBoardCard.settings.section.select.title"
      })
    })
  }), /*#__PURE__*/_jsx(DownCaratIcon, {
    alignWithText: true,
    color: "text-tertiary-default"
  })]
});